const formIncomplete = (state = false, action) => {
    switch (action.type) {
      case 'UPDATE_FORMINCOMPLETE':
        return action.formIncomplete
      default:
        return state    
    }
  }

  export default formIncomplete